export default "__VITE_ASSET__11ef2148__"